import { render } from "./LanguageSelectionModel.vue?vue&type=template&id=6f3f228b&scoped=true"
import script from "./LanguageSelectionModel.vue?vue&type=script&lang=js"
export * from "./LanguageSelectionModel.vue?vue&type=script&lang=js"

import "./LanguageSelectionModel.vue?vue&type=style&index=0&id=6f3f228b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3f228b"]])

export default __exports__